import qs from 'qs';
import store from '../store'
const Verifier = require('verify-cognito-token');

var AARP_ASI_AWS_ACCOUNT = "aarpasitest"
var PUBLIC_HTML_S3_BUCKET = "par.asitest.awsaarp.net"

var USER_POOL_ID = "us-east-1_SR1qv0AW0"
var CLIENT_ID = "1ejmkfce9njidhn4v6nep8njck"
var CLIENT_SECRET = "5vjfd4r19tkqfsppda1s4pogrhj87g5fn1bg35hsigktomjf7ii"
var ROOT_URL = `https://${AARP_ASI_AWS_ACCOUNT}.auth.us-east-1.amazoncognito.com`
var REDIRECT_URI = `https://${PUBLIC_HTML_S3_BUCKET}/oauth2/callback/`
var LOGOUT_URI = `https://${PUBLIC_HTML_S3_BUCKET}/loggedOut`


// For Local hosting (Uncomment the following for local hosting)

// USER_POOL_ID = "us-east-1_C1J0sXe8W"
// CLIENT_ID = "3q7ib2uco241unujt4kaag7546"
// CLIENT_SECRET = "1rvtd8jmh54mpa9jurlbhbcn0vlr015ujda9demcau20tvr13jcg"
// ROOT_URL = "https://aarpasidev.auth.us-east-1.amazoncognito.com"
// REDIRECT_URI = "http://localhost:8080/oauth2/callback"
// LOGOUT_URI = "http://localhost:8080/loggedOut"

var params = {
    region: USER_POOL_ID.substring(0,9),
    userPoolId: USER_POOL_ID
}
const verifier = new Verifier(params)

export default {
    login() {
        const queryString = {
            client_id: CLIENT_ID,
            response_type: 'code',
            redirect_uri: REDIRECT_URI

        };
        window.location = `${ROOT_URL}/oauth2/authorize?${qs.stringify(queryString)}` 
    },
    logout(){
        const queryString = {
            client_id: CLIENT_ID,
            response_type: 'token',
            redirect_uri: REDIRECT_URI,
            logout_uri: LOGOUT_URI
        }
        window.location = `${ROOT_URL}/logout?${qs.stringify(queryString)}`
    },
    exchange_token(code, callback){
        var data = `grant_type=authorization_code&client_id=${CLIENT_ID}&code=${code}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&client_secret=${CLIENT_SECRET}`;
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            // console.log(this.responseText);
            callback(JSON.parse(xhr.responseText))
        }
        });
        xhr.open("POST", `${ROOT_URL}/oauth2/token`);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send(data);
    },
    async get_new_id_token(callback){
        //function to fetch new id_token, access_token using the refresh_token.
        var refresh_token = window.localStorage.getItem('cognito_refresh_token')
        var data = `grant_type=refresh_token&client_id=${CLIENT_ID}&refresh_token=${refresh_token}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&client_secret=${CLIENT_SECRET}`;
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                // console.log(this.responseText);
                let resp = JSON.parse(xhr.responseText)
                if (resp['id_token'] !== undefined){
                    callback(resp)
                }else{
                    console.log(`Unable to refresh token: ${resp}`)
                    callback(null)
                }
            }
        });
        xhr.open("POST", `${ROOT_URL}/oauth2/token`);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send(data);
    },
    async verify_token(token){
        try{
            var params = {
                region: USER_POOL_ID.substring(0,9),
                userPoolId: USER_POOL_ID
            }
            const verifier = new Verifier(params)
            console.log(`verifying token: ${token}`)
            var status = await verifier.verify(token)
            return status
        } catch (e){
            console.log(e)
            return false
        }
        
    },
    async has_valid_local_token(token_type='id_token'){
        var token = false
        if (token_type == 'id_token'){
            token = window.localStorage.getItem('cognito_id_token')
        } else if (token_type == 'refresh_token'){
            token = window.localStorage.getItem('cognito_refresh_token')
        } else {
            console.log(`Invalid token type: ${token_type}`)
            return false
        }
        if(token){
            status = await this.verify_token(token)
            console.log(`${token_type} is valid: ${status}`)
            if(String(status) != "false"){
                return true
            }
        } 
        return false
    },
    get_id_token(callback){
        // Get validate local token, 
        // if token expired try to update tokens using refresh_token
        // if unable to refresh return false
        var id_token = window.localStorage.getItem('cognito_id_token')
        if (id_token){
            verifier.verify(id_token)
            .then(result => {
                console.log(`Token verification result: ${result}`)
                if(result){
                    console.log('returning token')
                    callback(id_token)
                } else {
                    var refresh_token = window.localStorage.getItem('cognito_refresh_token')
                    if (refresh_token){
                        this.get_new_id_token(function(data){
                            console.log(`Updated Tokens: ${data}`)
                            store.dispatch('updateToken', data)
                            if(data){
                                callback(data['id_token'])
                            } else {
                                callback(false)
                            } 
                        })
                    } else {
                        callback(false)
                    }
                }
            })
            .catch(error => {
                console.log(`Token verification error: ${error}`)
                callback(false)
            })
        }
    },
    async get_from_local_storage(id){
        status = await this.has_valid_local_token()
        console.log(`Token validity status: ${status} for id: ${id}`)
        if(status == true){
            if(id == "cognito_loggedIn"){
                return true
            } else {
                return window.localStorage.getItem(id)
            }
        } else {
            return null
        }
    }
} 